import { CompassIcon, HouseIcon } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";

import { StatusMessage } from "./status-screen";
import { useHomePath } from "./use-home-path";

export function NotFoundMessage() {
  const homePath = useHomePath();

  return (
    <StatusMessage
      icon={CompassIcon}
      eyebrow="404"
      title="Page not found"
      description="This page doesn't exist or has moved. Check the address, or head back and pick up where you left off."
      actions={
        <Button asChild>
          <Link to={homePath}>
            <HouseIcon />
            Go home
          </Link>
        </Button>
      }
    />
  );
}
